"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderMenu = exports.MenuComponent = void 0;
var app_1 = require("app");
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var react_transition_group_1 = require("react-transition-group");
var ConditionalLink_1 = __importDefault(require("../Link/ConditionalLink"));
var Sidebar_1 = __importDefault(require("../Sidebar"));
var HamburgerButton_1 = __importDefault(require("./HamburgerButton"));
var MenuService_1 = __importDefault(require("./MenuService"));
var MenuService_2 = require("./MenuService");
var SidebarMenu_1 = __importDefault(require("./SidebarMenu"));
var TransitionGroup_1 = __importDefault(require("react-transition-group/TransitionGroup"));
var client_1 = require("react-dom/client");
var GoogleAnalytics_1 = require("./GoogleAnalytics");
var MenuComponent = /** @class */ (function (_super) {
    __extends(MenuComponent, _super);
    function MenuComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.closedMenuIndex = -1;
        _this.languageISO = "en"; // default value
        _this.renderFirstLevel = function () {
            var menuItems = _this.props.menuItems;
            var firstLevelIndex = _this.state.firstLevelIndex;
            return (React.createElement("ul", { className: "df-navbar-main" }, (0, app_1.safe)(menuItems).map(function (item, i) {
                var classes = "";
                classes += firstLevelIndex === i ? " header__menu__list-item__link--active" : "";
                var hasChildren = !item.isClickable;
                var link = hasChildren ? __assign(__assign({}, item.clickableLink), { url: null }) : item.clickableLink;
                var onClick = function () {
                    // Send analytics to google (Menulink)
                    _this.sendGAEvent('link_click', {
                        'link_name': item.title, // Provide relevant information about where the link was clicked
                        'link_url': link // Provide a name for the link
                    });
                    _this.handleFirstLevelClick(i);
                };
                return (React.createElement("li", { key: i, className: "df-nav-item", onClick: hasChildren ? onClick : null },
                    React.createElement(ConditionalLink_1.default, { className: classes, link: link }, hasChildren ? item.title : item.clickableLink.caption),
                    _this.renderLinks(item.links)));
            })));
        };
        _this.renderLinks = function (linkGroup) {
            var listClass = "header__second-level-menu", itemClass = listClass + "-item", linkClass = itemClass + "__link";
            return (React.createElement("div", { className: listClass },
                React.createElement("div", { className: "df-container" }, (0, app_1.safe)(linkGroup).map(function (item, n) {
                    if (!item.url || !item.caption) {
                        return null;
                    }
                    return (React.createElement("div", { className: itemClass, key: n },
                        React.createElement(ConditionalLink_1.default, { className: linkClass, link: item }, item.caption)));
                }))));
        };
        _this.renderLogo = function () {
            var logoImageUrl = _this.props.headerControls.siteLogoItem.LogoImageUrl;
            var logoLinkUrl = _this.props.headerControls.siteLogoItem.LogoLinkUrl;
            var logoLinkName = _this.props.headerControls.siteLogoItem.LogoLinkName;
            var logoLinkTarget = _this.props.headerControls.siteLogoItem.LogoLinkTarget;
            if (logoImageUrl && logoImageUrl.length > 0) {
                return (React.createElement("div", { className: "header__menu__logo-wrapper" },
                    React.createElement("a", { className: "header__menu__logo", href: !!logoLinkUrl ? logoLinkUrl : "##", target: logoLinkTarget ? logoLinkTarget : "_self" },
                        React.createElement("img", { className: "logo", src: logoImageUrl, alt: "Turbocor" }))));
            }
            return (React.createElement("div", { className: "flaot-left" }, "\u00A0"));
        };
        _this.renderMobileMenu = function () {
            var _a = _this.state, visibleMobileMenu = _a.visibleMobileMenu, visibleAppSwitcher = _a.visibleAppSwitcher;
            return (React.createElement(Sidebar_1.default, { opened: visibleMobileMenu, closeBreakpoint: 7 /* Breakpoint.LGScreen */, close: _this.closeMobileMenu },
                React.createElement(SidebarMenu_1.default, { close: _this.closeMobileMenu, headerControls: _this.props.headerControls, menuItems: _this.props.menuItems, loginMenu: _this.props.loginMenu, toggleAppSwitcher: _this.toggleAppSwitcher, visibleAppSwitcher: visibleAppSwitcher })));
        };
        _this.showMobileMenu = function () {
            _this.setState({ visibleMobileMenu: true });
            MenuService_2.MobileSidebarService.setSidebarState(false);
        };
        _this.closeMenu = function () {
            _this.handleFirstLevelClick(_this.closedMenuIndex);
        };
        _this.closeMobileMenu = function () {
            MenuService_2.MobileSidebarService.setSidebarState(true);
            _this.setState({
                visibleAppSwitcher: false,
                visibleMobileMenu: false
            });
        };
        _this.handleFirstLevelClick = function (firstLevelIndex) {
            _this.setState({
                firstLevelIndex: firstLevelIndex === _this.state.firstLevelIndex ? _this.closedMenuIndex : firstLevelIndex,
            });
        };
        _this.toggleAppSwitcher = function () {
            _this.setState(function (prevState) { return ({
                visibleAppSwitcher: !prevState.visibleAppSwitcher
            }); });
        };
        _this.state = {
            firstLevelIndex: _this.closedMenuIndex,
            loading: false,
            secondLevelIndex: _this.closedMenuIndex,
            visibleAppSwitcher: false,
            visibleMobileMenu: false,
        };
        _this.menuElem = $(".header__first-level-menu").empty()[0];
        _this.menuService = new MenuService_1.default(_this.props.pageId);
        _this.analyticsConfig = _this.props.googleAnalytics;
        _this.languageISO = _this.props.headerControls.siteLanguageLabel;
        return _this;
    }
    MenuComponent.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(HamburgerButton_1.default, { onClick: this.showMobileMenu }),
            this.renderMenu(),
            this.renderMobileMenu(),
            React.createElement(GoogleAnalytics_1.GoogleAnalytics, { tagManagerId: this.analyticsConfig.tagManagerId, analyticsId: this.analyticsConfig.analyticsId, applicationUrl: this.analyticsConfig.applicationUrl, googleAnalyticsUserId: this.analyticsConfig.googleAnalyticsUserId, language: this.languageISO })));
    };
    MenuComponent.prototype.renderMenu = function () {
        var firstLevelIndex = this.state.firstLevelIndex;
        var isOpennedMenu = firstLevelIndex !== this.closedMenuIndex;
        var menu = (React.createElement("div", { className: isOpennedMenu ? "header__first-level-menu__opened" : null },
            React.createElement(TransitionGroup_1.default, null, isOpennedMenu && React.createElement(react_transition_group_1.CSSTransition, { key: "menu-overlay", classNames: "header__menu--fade", timeout: 200 },
                React.createElement("div", { className: "overlay", onClick: this.closeMenu }))),
            React.createElement("div", { className: "header__first-level-menu__wrapper" },
                React.createElement("div", { className: "header__first-level-menu__separator" },
                    React.createElement("div", { className: "df-nav" },
                        React.createElement("div", { className: "df-container " },
                            React.createElement("div", { className: "df-flex" },
                                this.renderLogo(),
                                this.renderFirstLevel())))))));
        return ReactDOM.createPortal(menu, this.menuElem);
    };
    MenuComponent.prototype.sendGAEvent = function (eventName, eventParams) {
        var googleAnalyticsSettings = $(".header__mobile-menu-wrapper").data("google-analytics");
        var acceptance = (0, GoogleAnalytics_1.getCookieCategoriesAcceptance)();
        if (acceptance && acceptance.statistic) {
            gtag('config', googleAnalyticsSettings.tagManagerId);
            gtag('event', eventName, eventParams);
        }
    };
    return MenuComponent;
}(React.Component));
exports.MenuComponent = MenuComponent;
function RenderMenu(data, element) {
    var root = (0, client_1.createRoot)(element);
    root.render(React.createElement(MenuComponent, __assign({}, data)));
}
exports.RenderMenu = RenderMenu;
